import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { Add, Delete, Download, FilterList, MoreVert, Search, FirstPage, LastPage, Close, PhotoCamera, Remove } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import MapPinLocation from "../../../shared/components/MapPinLocation.tsx";

import { useNavigate } from "react-router-dom";

import {
  downloadAttachmentFile,
  deleteAttachment,
  OfficeAttachment,
  getOfficeAttachments
} from "../../data_management/services/officeService.tsx";

import { OfficeProjectSearchParams, getOfficeProjects, createOfficeProject, uploadOfficePhoto, editOfficeProject, fetchOfficePhotoBlob, deleteOfficeProject, getOfficeLocations, getAllOffices } from "../services/projectDetailServices.tsx";
import { LocationSearchParams, getLocations, createLocation, editLocation, deleteLocation } from "../../data_management/services/locationService.tsx";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

// Dummy Data
const officeTypes = ["PST", "MB", "PJTK", "KON", "SK"];

const officeTypeColors = {
  "PST": "green",
  "MB": "lightgreen",
  "PJTK": "	#164396",
  "KON": "gray",
  "SK": "orange"
};

const regions = ["Jamali", "Sulmapana", "Sumkal"];

const ProjectDetail: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddOfficeDialog, setOpenAddOfficeDialog] = useState(false);
  const [openAddItemDetailsDialog, setOpenAddItemDetailsDialog] = useState(false);

  const [error, setError] = useState("");
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [filters, setFilters] = useState([{ field: "name", value: "" }]);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [officeOptions, setOfficeOptions] = useState<any[]>([]);
  const [itemsToDelete, setItemsToDelete] = useState<any[]>([]);


  const offset = (currentPage - 1) * rowsPerPage;

  const [sortConfig, setSortConfig] = useState<{ orderBy: string; order: "asc" | "desc" }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const showPopupMandatoryError = () => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: "Lengkapi data yang wajib diisi.",
    });
  };

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };


  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "officeName", label: "Office Name" },
    { value: "officeAddress", label: "Office Address" },
    { value: "officeEmail", label: "Office Email" },
    { value: "officeType", label: "Office Type" },
    { value: "region", label: "Region" },
  ];

  // Daftar pilihan filter yang tersedia
  const availableFiltersInit = [
    { value: "officeName", label: "Office Name" },
    { value: "officeAddress", label: "Office Address" },
    { value: "officeEmail", label: "Office Email" },
    { value: "officeType", label: "Office Type" },
    { value: "region", label: "Region" },
  ];

  const [filterParams, setFilterParams] = useState<{
    keyword?: string;
    officeName?: string;
    officeAddress?: string;
    region?: string;
    officeType?: string;
    officeEmail?: string;
    managerName?: string;
    contactNumber?: string;
    startDate?: string;
    endDate?: string;
    limit?: number;
    offset?: number;
    orderBy?: string;
    order?: string;
  }>({});

  const displayedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const fetchOfficeList = async () => {
    try {
      const result = await getAllOffices();
      setOfficeOptions(result.data); // Simpan data office dari backend
    } catch (error) {
      console.error("Failed to fetch offices:", error);
    }
  };

  const fetchOffices = async () => {
    setIsLoading(true);
    try {


      const result = await getOfficeProjects({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });


      setRows(result.data);
      setTotalPages(result.pagination.totalPages);
      setTotalItems(result.total);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data on mount
  useEffect(() => {
    fetchOfficeList();
    fetchOffices();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  const initOfficeProjectData = {
    officeId: "",
    buildingValuation: "",
    identifierMB: "MB",
  }

  const [officeProjectData, setOfficeProjectData] = useState<{
    officeId: string,
    buildingValuation: string,
    identifierMB: string,
  }>(initOfficeProjectData);

  const initOfficeData = {
    officeId: "",
    officeName: "",
    officeAddress: "",
    latitude: "",
    longitude: "",
    region: "",
    province: "",
    city: "",
    district: "",
    managerName: "",
    contactNumber: "",
    officeEmail: "",
    officeType: "",
    Locations: [],
    file: null,
    photoOffice: "",
    previewUrl: "",
    attachments: [], // Tambahkan ini
  };

  const [officeData, setOfficeData] = useState<{
    officeId: string,
    officeName: string,
    officeAddress: string,
    latitude: string,
    longitude: string,
    region: string,
    province: string,
    city: string,
    district: string,
    managerName: string,
    contactNumber: string,
    officeEmail: string,
    officeType: string,
    Locations: any[],
    file: File | null;
    photoOffice: string;
    previewUrl: string;
  }>(initOfficeData);

  const [errors, setErrors] = useState({
    officeId: false,
    buildingValuation: false,
  });

  // State untuk office detail lengkap
  const [officeDetail, setOfficeDetail] = useState<{
    officeId: string,
    officeName: string,
    officeAddress: string,
    latitude: string,
    longitude: string,
    region: string,
    province: string,
    city: string,
    district: string,
    managerName: string,
    contactNumber: string,
    officeEmail: string,
    officeType: string,
    Locations: any[],
    photoOffice: string;
    previewUrl: string;
    attachments: any[];
  }>({
    officeId: "",
    officeName: "",
    officeAddress: "",
    latitude: "",
    longitude: "",
    region: "",
    province: "",
    city: "",
    district: "",
    managerName: "",
    contactNumber: "",
    officeEmail: "",
    officeType: "",
    Locations: [],
    photoOffice: "",
    previewUrl: "",
    attachments: [],
  });

  const [editOfficeDetail, setEditOfficeDetail] = useState<{
    officeId: string,
    officeName: string,
    officeAddress: string,
    latitude: string,
    longitude: string,
    region: string,
    province: string,
    city: string,
    district: string,
    managerName: string,
    contactNumber: string,
    officeEmail: string,
    officeType: string,
    Locations: any[],
    photoOffice: string;
    previewUrl: string;
    attachments: any[];
  }>({
    officeId: "",
    officeName: "",
    officeAddress: "",
    latitude: "",
    longitude: "",
    region: "",
    province: "",
    city: "",
    district: "",
    managerName: "",
    contactNumber: "",
    officeEmail: "",
    officeType: "",
    Locations: [],
    photoOffice: "",
    previewUrl: "",
    attachments: [],
  });

  const [openEditOfficeDialog, setOpenEditOfficeDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const initEditOfficeProjectData = {
    id: "",
    officeId: "",
    buildingValuation: "",
    identifierMB: "MB",
  };
  const [editOfficeProjectData, setEditOfficeProjectData] = useState<{
    id: string,
    officeId: string,
    buildingValuation: string,
    identifierMB: string,
  }>(initEditOfficeProjectData);

  const initEditOfficeData = {
    id: "",
    locationId: "",
    officeId: "",
    officeName: "",
    officeAddress: "",
    latitude: "",
    longitude: "",
    region: "",
    province: "",
    city: "",
    district: "",
    managerName: "",
    contactNumber: "",
    officeEmail: "",
    officeType: "",
    Locations: [],
    file: null,
    photoOffice: "",
    previewUrl: "",
    attachments: [], // Tambahkan ini
  };

  const [editOfficeData, setEditOfficeData] = useState<{
    id: string,
    locationId: string,
    officeId: string,
    officeName: string,
    officeAddress: string,
    latitude: string,
    longitude: string,
    region: string,
    province: string,
    city: string,
    district: string,
    managerName: string,
    contactNumber: string,
    officeEmail: string,
    officeType: string,
    Locations: any[],
    file: File | null;
    photoOffice: string;
    previewUrl: string;
  }>(initEditOfficeData);

  const [originalEditOfficeData, setOriginalEditOfficeData] = useState<{
    id: string,
    locationId: string,
    officeId: string,
    officeName: string,
    officeAddress: string,
    latitude: string,
    longitude: string,
    region: string,
    province: string,
    city: string,
    district: string,
    managerName: string,
    contactNumber: string,
    officeEmail: string,
    officeType: string,
    Locations: any[],
    file: File | null;
    photoOffice: string;
    previewUrl: string;
  }>({
    id: "",
    locationId: "",
    officeId: "",
    officeName: "",
    officeAddress: "",
    latitude: "",
    longitude: "",
    region: "",
    province: "",
    city: "",
    district: "",
    managerName: "",
    contactNumber: "",
    officeEmail: "",
    officeType: "",
    Locations: [],
    file: null,
    photoOffice: "",
    previewUrl: "",
  });

  const [editErrors, setEditErrors] = useState({
    officeId: false,
    buildingValuation: false,
    identifierMB: false,

  });

  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = (file: File) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setOfficeData({ ...officeData, file });
  };

  const handleEditFileUpload = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setEditOfficeData({ ...editOfficeData, file });
  };

  // Fungsi untuk download attachment
  const handleDownloadAttachment = async (attachment: any) => {
    try {
      // Validation
      if (!attachment?.attachmentId) {
        throw new Error('Data attachment tidak valid');
      }

      Swal.fire({
        title: 'Mengunduh...',
        text: `Mempersiapkan "${attachment.originalName}"`,
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      // Timeout handling
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Timeout: Download terlalu lama')), 30000)
      );

      // Download dengan timeout
      await Promise.race([
        downloadAttachmentFile(attachment.attachmentId, attachment.originalName),
        timeoutPromise
      ]);

      Swal.close();

      // Success feedback
      Swal.fire({
        icon: 'success',
        title: 'Berhasil Diunduh',
        text: `File "${attachment.originalName}" telah diunduh`,
        timer: 1500,
        showConfirmButton: false
      });

    } catch (error: any) {
      Swal.close();

      let errorMessage = 'Gagal mengunduh file';
      if (error.message.includes('Timeout')) {
        errorMessage = 'Download timeout. Coba lagi.';
      } else if (error.message.includes('tidak ditemukan')) {
        errorMessage = 'File tidak ditemukan di server.';
      } else if (error.message.includes('akses')) {
        errorMessage = 'Anda tidak memiliki akses ke file ini.';
      } else {
        errorMessage = error.message || 'Terjadi kesalahan tidak diketahui';
      }

      Swal.fire({
        icon: 'error',
        title: 'Download Gagal',
        text: errorMessage,
        confirmButtonColor: '#0F62FE',
      });
    }
  };

  // Helper function untuk load office data
  // Helper function untuk load office data
  const loadOfficeData = async (officeId: string) => {
    if (!officeId) return null;

    try {
      const selectedOffice = officeOptions.find(opt => opt.officeId === officeId);
      if (!selectedOffice) {
        console.warn("Office tidak ditemukan:", officeId);
        return null;
      }

      let officeAttachment = [];
      try {
        officeAttachment = await getOfficeAttachments(officeId);
      } catch (attachmentError) {
        console.warn("Gagal memuat attachments:", attachmentError);
        // Lanjut tanpa attachments
      }

      // Ambil preview URL untuk foto office jika ada
      let previewUrl = "";
      if (selectedOffice.photoOffice && typeof selectedOffice.photoOffice === "string") {
        try {
          previewUrl = await fetchOfficePhotoBlob(selectedOffice.photoOffice);
        } catch (photoError) {
          console.warn("Gagal memuat foto office:", photoError);
        }
      }

      return {
        ...selectedOffice,
        locationId: selectedOffice.Locations?.[0]?.locationId || "",
        city: selectedOffice.Locations?.[0]?.city || "",
        province: selectedOffice.Locations?.[0]?.province || "",
        district: selectedOffice.Locations?.[0]?.district || "",
        region: selectedOffice.region || "",
        longitude: selectedOffice.Locations?.[0]?.longitude || "",
        latitude: selectedOffice.Locations?.[0]?.latitude || "",
        attachments: officeAttachment,
        previewUrl: previewUrl,
      };
    } catch (error) {
      console.error("Error dalam loadOfficeData:", error);
      return null;
    }
  };

  const handleOfficeInputChange = async (e) => {
    const { name, value } = e.target;

    // Selalu update project data
    setOfficeProjectData(prev => ({ ...prev, [name]: value }));

    if (name === "officeId") {
      if (value) {
        // Tampilkan loading state jika perlu
        setIsLoading(true);

        try {
          const officeData = await loadOfficeData(value);
          if (officeData) {
            setOfficeData(officeData);
            console.log("Office data loaded:", officeData);
          } else {
            // Jika gagal load, reset ke initial
            setOfficeData(initOfficeData);
          }
        } catch (error) {
          console.error("Gagal memuat data office:", error);
          setOfficeData(initOfficeData);
        } finally {
          setIsLoading(false);
        }
      } else {
        // Reset jika value kosong
        setOfficeData(initOfficeData);
      }
    }
  };

  const handleEditOfficeInputChange = async (e) => {
    const { name, value } = e.target;

    // Selalu update project data
    setEditOfficeProjectData(prev => ({ ...prev, [name]: value }));

    if (name === "officeId") {
      if (value) {
        // Tampilkan loading state jika perlu
        setIsLoading(true);

        try {
          const officeData = await loadOfficeData(value);
          if (officeData) {
            setEditOfficeData(officeData);
            console.log("Edit office data loaded:", officeData);
          } else {
            // Jika gagal load, reset ke initial
            setEditOfficeData(initEditOfficeData);
          }
        } catch (error) {
          console.error("Gagal memuat data edit office:", error);
          setEditOfficeData(initEditOfficeData);
        } finally {
          setIsLoading(false);
        }
      } else {
        // Reset jika value kosong
        setEditOfficeData(initEditOfficeData);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOfficeProjectData({ ...officeProjectData, [name]: value })
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditOfficeProjectData({ ...editOfficeProjectData, [name]: value });
  };

  const validateForm = () => {
    let newErrors = {
      officeId: !officeProjectData.officeId,
      buildingValuation: !officeProjectData.buildingValuation,
      identifierMB: !officeProjectData.identifierMB,
    };

    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const validateEditForm = () => {
    let newErrors = {
      officeId: !editOfficeProjectData.officeId,
      buildingValuation: !editOfficeProjectData.buildingValuation,
      identifierMB: !editOfficeProjectData.identifierMB,
    };

    setEditErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const errorResponse = (title, error) => {
    let errorTitle = "";
    let errorDetails = "";

    // Handle backend error response
    if (error.response?.data) {
      const backendError = error.response.data;

      // Debug log untuk melihat struktur error
      console.log(
        "Backend Error Structure:",
        JSON.stringify(backendError, null, 2)
      );

      // Main error message
      errorTitle = backendError.error || errorTitle;

      // Handle all possible email validation error formats - PERBAIKAN UTAMA
      const isEmailValidationError =
        // Case 1: Error in details (Sequelize style)
        (backendError.details &&
          /validation isEmail on (email|officeEmail)/i.test(
            backendError.details
          )) ||
        // Case 2: Error in errors array (Sequelize validation errors)
        (backendError.errors &&
          backendError.errors.some(
            (err: any) =>
              (err.path === "email" || err.path === "officeEmail") &&
              err.validatorKey === "isEmail"
          )) ||
        // Case 3: Error in message (generic API responses)
        (backendError.message &&
          /email.*invalid/i.test(backendError.message));

      if (isEmailValidationError) {
        errorTitle = "Format Email Tidak Valid";
        errorDetails =
          "• Format email tidak valid (contoh: nama@perusahaan.com)";
      }
      // Only use details if not an email error
      else if (backendError.details) {
        errorDetails = backendError.details;
      }

      // Handle validation errors (improved processing)
      if (backendError.errors) {
        const validationMessages = backendError.errors
          .map((err: any) => {
            // Handle both array and object error formats
            const errorObj = Array.isArray(err) ? err[0] : err;

            // Skip email errors since we already handled them
            if (
              (errorObj.path === "email" ||
                errorObj.path === "officeEmail") &&
              errorObj.validatorKey === "isEmail"
            ) {
              return null;
            }
            return `• ${errorObj.message || "Terjadi kesalahan validasi"}`;
          })
          .filter(Boolean) // Remove null entries
          .join("\n");

        if (validationMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${validationMessages}`
            : validationMessages;
        }
      }

      // Handle duplicate fields (improved formatting)
      if (backendError.duplicates) {
        const duplicateMessages = backendError.duplicates
          .map((dup: any) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
          .join("\n");

        if (duplicateMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${duplicateMessages}`
            : duplicateMessages;
        }
      }
    }
    // Handle network or other errors
    else {
      errorDetails =
        error.message || "Terjadi kesalahan jaringan atau server";
    }

    // Show error in Swal (improved formatting)
    Swal.fire({
      icon: "error",
      title: title,
      html: `
                <div style="text-align: left;">
                  <p style="font-weight: bold; margin-bottom: 10px; color: #d32f2f;">
                    ${errorTitle}
                  </p>
                  ${errorDetails
          ? `<div style="
                          color: #5f2120;
                          background: #fdecea;
                          padding: 12px;
                          border-radius: 4px;
                          font-size: 0.9em;
                          border-left: 4px solid #d32f2f;
                          line-height: 1.5;
                        ">
                          ${errorDetails.replace(/\n/g, "<br>")}
                        </div>`
          : ""
        }
                </div>
              `,
      confirmButtonColor: "#0F62FE",
      width: "600px",
    });
  }


  const handleSubmitAddOffice = async () => {
    if (validateForm()) {
      try {
        // Step 1: Create office
        await console.log(officeProjectData);
        const newOffice = await createOfficeProject(officeProjectData); // get response with `id` or `code`




        Swal.fire({
          icon: "success",
          title: "Office berhasil ditambahkan",
          confirmButtonColor: "#0F62FE",
        });
        setOpenAddOfficeDialog(false);
        setOfficeData(initOfficeData);

        setOfficeProjectData(initOfficeProjectData);

        await fetchOffices();

      } catch (error: any) {
        let title = await "Gagal membuat office";
        await errorResponse(title, error);
      }

    } else {
      showPopupMandatoryError();
    }
  };

  const handleSubmitEditOffice = async () => {
    if (validateEditForm()) {
      try {
        const updatedOffice = await editOfficeProject(editOfficeProjectData);

        await fetchOffices();

        Swal.fire({
          icon: "success",
          title: "Office berhasil diubah",
          confirmButtonColor: "#0F62FE",
        });

        await setOpenEditOfficeDialog(false);
        await setIsEditing(false);

        // Optional: refresh item list
        await setCurrentPage(1); // agar fetch ulang
      } catch (error) {
        let title = await "Gagal mengubah office";
        await errorResponse(title, error);
      }

    } else {
      showPopupMandatoryError();
    }
  };

  const handleOpenEditOffice = async (row) => {
    try {
      // Set project data
      await setEditOfficeProjectData({
        id: row.id,
        officeId: row.officeId,
        buildingValuation: row.buildingValuation,
        identifierMB: row.identifierMB,
      });

      // Load detail office lengkap menggunakan fungsi yang sudah ada
      const officeData = await loadOfficeData(row.officeId);
      if (officeData) {
        await setEditOfficeData(officeData);
      }

      // Simpan original data untuk cancel
      await setOriginalEditOfficeData({
        ...row,
        ...officeData
      });

      await setIsEditing(false);
      await setOpenEditOfficeDialog(true);

    } catch (error) {
      console.error("Gagal membuka edit office:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal Memuat Data",
        text: "Tidak dapat memuat data office lengkap",
      });
    }
  };

  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteRows = async () => {
    try {
      await Promise.all(selectedRows.map(async (id) => {
        const deletedOffice = await deleteOfficeProject(id);

      }));

      Swal.fire({
        icon: "success",
        title: "Office berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      fetchOffices(); // refresh data
      setOpenDeleteDialog(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus item",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleCancelEditOffice = () => {
    setEditOfficeData(originalEditOfficeData); // Kembalikan nilai asli
    setIsEditing(false); // Kunci kembali form
    setOpenEditOfficeDialog(false);
  };

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "id", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `OfficeProjectSearchParams`
      const searchParams: OfficeProjectSearchParams = {};

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getOfficeProjects(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getOfficeProjects({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams(
        {
          keyword: searchQuery
        }
      );
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: 'Preparing Export...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Opsi 1: Export semua data (dengan filter yang sama seperti tabel)
      const exportData = await getExportData();

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatEmployeeForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one employee to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.id))
      //   .map(formatEmployeeForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Office");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Offices_${date}.xlsx`);

      // Tutup loading
      Swal.close();

    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.message || 'Failed to export office data',
      });
    }
  };

  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async () => {
    const allOffices = await getOfficeProjects({
      ...filterParams,
      limit: 100000000, // Ambil semua data
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    return allOffices.data.map(officeProject => ({
      'Office Name': officeProject.office.officeName,
      'Building Valuation': `${Math.round(Number(officeProject.buildingValuation))}` || "-",
      'Office Email': officeProject.office.officeEmail,
      'Office Address': officeProject.office.officeAddress,
      'Manager Name': officeProject.office.managerName,
      'Office Contact': officeProject.office.contactNumber,
      'Office Type': officeProject.office.officeType,
    }));
  };

  return (
    isLoading ? <LoadingOverlay /> :
      <Box sx={{ padding: 3 }}>
        {/* Header & Tabs */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
          <Typography variant="h6" fontWeight="bold">
            Office List
          </Typography>
        </Box>

        {/* Toolbar */}
        <Box className="toolbar">
          {/* Left Controls */}
          <Box className="leftControls">
            <Typography>Show</Typography>
            <Select value={rowsPerPage} onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }} size="small">
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>

            {/* Search Button & Input */}
            <Button
              variant="contained"
              startIcon={<Search />}
              onClick={() => setShowSearch((prev) => !prev)}
              className="searchButton"
            >
              Search
            </Button>
            {showSearch && (
              <TextField
                variant="outlined"
                size="small"
                placeholder="Search"
                value={searchQuery}
                onChange={async (e) => {
                  await setSearchQuery(e.target.value);
                }}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
                autoFocus
                className="searchInput"
              />
            )}

            {/* Menampilkan Error */}
            {error && <p style={{ color: "red" }}>{error}</p>}
          </Box>

          {/* Right Controls */}
          <Box className="rightControls">
            <Button
              startIcon={<Delete />}
              variant="text"
              onClick={() => {
                const selectedData = rows.filter((row) => selectedRows.includes(row.officeId));
                setItemsToDelete(selectedData);
                setOpenDeleteDialog(true);
              }}
              disabled={selectedRows.length === 0}
            >
              Delete
            </Button>
            {/* Filter Button */}
            <Button
              startIcon={<FilterList />}
              variant="text"
              onClick={() => setOpenFilterDialog(true)}
            >
              Filters
            </Button>
            <Button startIcon={<Download />} variant="contained" className="exportButton" onClick={() => handleExport()}>
              Export
            </Button>
            <Button startIcon={<Add />} variant="contained" className="addItemDetailsButton" onClick={() => setOpenAddOfficeDialog(true)}>
              Add New Office
            </Button>
          </Box>
        </Box>


        {/* Delete Button & Subtitle */}

        <Box className="deleteContainer">
          <Typography variant="body2" className="detailsSubtitle">
            Details List Of All Offices
          </Typography>
        </Box>


        {/* Table */}
        <TableContainer component={Paper} className="tableContainer">
          <Table className="table">
            <TableHead className="tableHead">
              <TableRow>
                {/* Checkbox header */}
                <TableCell padding="checkbox" className="tableCell">
                  <Checkbox
                    indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                    checked={selectedRows.length === rows.length}
                    onChange={() =>
                      setSelectedRows(selectedRows.length === rows.length ? [] : rows.map((row) => row.officeId))
                    }
                  />
                </TableCell>
                <TableCell>No</TableCell>
                {/* Header dengan sorting */}
                <TableCell className="tableCell" onClick={() => handleSort("office.officeName")} style={{ cursor: "pointer" }}>
                  <strong>Office Name</strong>
                  {sortConfig.orderBy === "office.officeName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("buildingValuation")} style={{ cursor: "pointer" }}>
                  <strong>Building Valuation</strong>
                  {sortConfig.orderBy === "buildingValuation" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("office.officeEmail")} style={{ cursor: "pointer" }}>
                  <strong>Office Email</strong>
                  {sortConfig.orderBy === "office.officeEmail" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("office.officeAddress")} style={{ cursor: "pointer" }}>
                  <strong>Office Address</strong>
                  {sortConfig.orderBy === "office.officeAddress" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("office.managerName")} style={{ cursor: "pointer" }}>
                  <strong>Manager Name</strong>
                  {sortConfig.orderBy === "office.managerName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("office.contactNumber")} style={{ cursor: "pointer" }}>
                  <strong>Office Contact</strong>
                  {sortConfig.orderBy === "office.contactNumber" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("office.officeType")} style={{ cursor: "pointer" }}>
                  <strong>Office Type</strong>
                  {sortConfig.orderBy === "office.officeType" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell">
                </TableCell> {/* Kolom untuk aksi */}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  {/* Checkbox */}
                  <TableCell padding="checkbox" className="tableCell">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  {/* Data */}
                  <TableCell className="tableCell" title={row.office.officeName}><strong>{row.office.officeName}</strong></TableCell>
                  <TableCell className="tableCell" title={row.buildingValuation}>{`Rp ${Number(row.buildingValuation).toLocaleString("id-ID")}`}</TableCell>
                  <TableCell className="tableCell" title={row.office.officeEmail}>{row.office.officeEmail}</TableCell>
                  <TableCell className="tableCell" title={row.office.officeAddress}>{row.office.officeAddress}</TableCell>
                  <TableCell className="tableCell" title={row.office.managerName}>{row.office.managerName}</TableCell>
                  <TableCell className="tableCell" title={row.office.contactNumber}>{row.office.contactNumber}</TableCell>
                  {/* Status Badge */}
                  <TableCell className="tableCell" title={row.office.officeType}>
                    <Box className="statusBadge" style={{ backgroundColor: officeTypeColors[row.office.officeType] ? officeTypeColors[row.office.officeType] : "grey" }}>
                      {row.office.officeType}
                    </Box>
                  </TableCell>
                  {/* Ikon More Options */}
                  {/* Ikon More Options */}
                  <TableCell className="tableCell">
                    <IconButton onClick={() => handleOpenEditOffice(row)}>
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>


        {/* Pagination */}
        <Box
          className="paginationContainer"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "16px 0",
          }}
        >
          {/* Info jumlah data */}
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {`Showing ${offset + 1} to ${Math.min(
              offset + rowsPerPage,
              totalItems
            )} of ${totalItems} entries`}
          </Typography>

          {/* Komponen Pagination */}
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(e, page) => setCurrentPage(page)}
            className="pagination"
            showFirstButton
            showLastButton
            renderItem={(item) => (
              <PaginationItem
                {...item}
                components={{ first: FirstPage, last: LastPage }}
              />
            )}
          />
        </Box>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
          <DialogTitle>Delete Rows?</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to delete the selected rows?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
            <Button onClick={handleDeleteRows} color="error">Delete</Button>
          </DialogActions>
        </Dialog>

        {/* POPUP Add New Office */}
        <Dialog open={openAddOfficeDialog} onClose={() => setOpenAddOfficeDialog(false)} fullWidth maxWidth="lg"
          sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">Add New Office</Typography>
              <IconButton onClick={() => setOpenAddOfficeDialog(false)} color="error"><Close /></IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
              {/* Left Side (Inputs & Map) */}
              <Box sx={{ flex: 1 }}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Autocomplete
                    fullWidth
                    options={officeOptions}
                    getOptionLabel={(option) => option.officeName || ""}
                    value={officeOptions.find(opt => opt.officeId === officeProjectData.officeId) || null}

                    onChange={(event, newValue) => {
                      const target = {
                        target: {
                          name: "officeId",
                          value: newValue ? newValue.officeId : ""
                        }
                      };
                      handleInputChange(target);
                      handleOfficeInputChange(target);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Office Location"
                        placeholder="Select Office"
                        // margin="dense"
                        fullWidth error={!officeProjectData.officeId}
                        helperText={!officeProjectData.officeId ? "Mandatory Field" : ""}
                      />
                    )}
                  />
                  <TextField
                    fullWidth label="Input Building Valuation" name="buildingValuation"
                    placeholder="Enter building valuation" value={officeProjectData.buildingValuation}
                    error={!officeProjectData.buildingValuation}
                    helperText={!officeProjectData.buildingValuation ? "Mandatory Field" : ""}
                    onChange={handleInputChange}
                  />
                </Box>

                {/* Map Placeholder */}
                <Box sx={{ width: "100%", height: "auto", bgcolor: "inherit", display: "flex", alignItems: "center", justifyContent: "center", my: 2 }}>
                  <MapPinLocation
                    latitude={officeData.latitude}
                    longitude={officeData.longitude}
                    disabled
                    onSelect={({ lat, lng }) => {
                      if (isEditing) {
                        setOfficeData({ ...officeData, latitude: lat.toString(), longitude: lng.toString() });
                      }
                      // else {
                      //   setOfficeData({ ...officeData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                    }}
                  />

                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField fullWidth label="Input Latitude" name="latitude"
                    placeholder="Enter latitude" value={officeData.latitude ? officeData.latitude : ""}

                    disabled
                  />
                  <TextField fullWidth label="Input Longitude" name="longitude"
                    placeholder="Enter longitude" value={officeData.longitude ? officeData.longitude : ""}

                    disabled
                  />
                </Box>
                {/* File Upload Section */}
                {/* Office Photo */}
                {officeData.previewUrl && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                      Office Photo
                    </Typography>
                    <Box
                      sx={{
                        border: "1px solid #e0e0e0",
                        padding: 2,
                        borderRadius: "8px",
                        backgroundColor: "#fafafa",
                        textAlign: "center"
                      }}
                    >
                      <img
                        src={officeData.previewUrl}
                        alt="Office"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "8px",
                          objectFit: "contain",
                          maxHeight: 200,
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>

              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>

                <TextField
                  fullWidth label="Office Address" name="officeAddress"
                  placeholder="Enter Office Address" value={officeData.officeAddress}

                  disabled
                />
                <TextField
                  select
                  fullWidth label="Input Office Region" name="region"
                  placeholder="Enter region" value={officeData.region}

                  disabled
                >
                  <MenuItem value="">Select Region</MenuItem>
                  {regions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  fullWidth label="Input Province" name="province"
                  placeholder="Enter province" value={officeData.province}

                  disabled
                />
                <TextField
                  fullWidth label="Input City" name="city"
                  placeholder="Enter city" value={officeData.city}

                  disabled
                />
                <TextField
                  fullWidth label="Input District" name="district"
                  placeholder="Enter district" value={officeData.district}

                  disabled
                />
                <TextField
                  fullWidth label="Input Office Manager" name="managerName"
                  placeholder="Enter manager name" value={officeData.managerName}

                  disabled
                />

                {/* Office Contact & Email */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Input Office Contact Number" name="contactNumber"
                    placeholder="Enter contact number" value={officeData.contactNumber}

                    disabled
                  />
                  <TextField
                    fullWidth label="Input Office Email" name="officeEmail"
                    placeholder="Enter email" value={officeData.officeEmail}

                    disabled
                  />
                </Box>

                <TextField
                  select
                  fullWidth label="Input Office Type" name="officeType"
                  placeholder="Enter office type" value={officeData.officeType}

                  disabled
                >
                  <MenuItem value="">Select Office Type</MenuItem>
                  {officeTypes.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                {/* Office Attachments */}
                {officeData.attachments && officeData.attachments.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                      Office Attachments ({officeData.attachments.length})
                    </Typography>
                    <Box sx={{ maxHeight: 200, overflow: 'auto' }}>
                      {officeData.attachments.map((attachment, index) => (
                        <Box
                          key={attachment.attachmentId}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: 2,
                            border: "1px solid #e0e0e0",
                            borderRadius: 1,
                            mb: 1,
                            backgroundColor: "white"
                          }}
                        >
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight="bold">
                              {attachment.originalName}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {(attachment.fileSize / 1024 / 1024).toFixed(2)} MB • {new Date(attachment.createdAt).toLocaleDateString('id-ID')}
                            </Typography>
                            {attachment.description && (
                              <Typography variant="caption" display="block" color="textSecondary">
                                {attachment.description}
                              </Typography>
                            )}
                          </Box>
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleDownloadAttachment(attachment)}
                            title="Download File"
                          >
                            <Download />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </DialogContent>

          {/* Dialog Actions */}
          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            <Button variant="outlined" color="error" sx={{ width: 120 }} onClick={() => setOpenAddOfficeDialog(false)}>CANCEL</Button>
            <Button variant="contained" color="success" sx={{ width: 120 }} onClick={handleSubmitAddOffice}>SAVE</Button>
          </DialogActions>
        </Dialog>

        {/* POPUP Edit Office */}
        <Dialog open={openEditOfficeDialog} onClose={() => setOpenEditOfficeDialog(false)} fullWidth maxWidth="lg"
          sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">Edit Office</Typography>
              <IconButton onClick={() => setOpenEditOfficeDialog(false)} color="error"><Close /></IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
              {/* Left Side (Inputs & Map) */}
              <Box sx={{ flex: 1 }}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Autocomplete
                    fullWidth
                    disabled={!isEditing}
                    options={officeOptions}
                    getOptionLabel={(option) => option.officeName || ""}
                    value={officeOptions.find(opt => opt.officeId === editOfficeProjectData.officeId) || null}

                    onChange={(event, newValue) => {
                      const target = {
                        target: {
                          name: "officeId",
                          value: newValue ? newValue.officeId : ""
                        }
                      };
                      handleEditInputChange(target);
                      handleEditOfficeInputChange(target);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Office Location"
                        placeholder="Select Office"
                        // margin="dense"
                        fullWidth error={!editOfficeProjectData.officeId}
                        helperText={!editOfficeProjectData.officeId ? "Mandatory Field" : ""}
                      />
                    )}
                  />
                  <TextField
                    fullWidth label="Input Building Valuation" name="buildingValuation"
                    placeholder="Enter building valuation" value={editOfficeProjectData.buildingValuation}
                    error={!editOfficeProjectData.buildingValuation}
                    helperText={!editOfficeProjectData.buildingValuation ? "Mandatory Field" : ""}
                    onChange={handleEditInputChange}
                    disabled={!isEditing}
                  />
                </Box>

                {/* Map Placeholder */}
                <Box sx={{ width: "100%", height: "auto", bgcolor: "inherit", display: "flex", alignItems: "center", justifyContent: "center", my: 2 }}>
                  <MapPinLocation
                    latitude={editOfficeData.latitude}
                    longitude={editOfficeData.longitude}
                    disabled
                    onSelect={({ lat, lng }) => {
                      if (isEditing) {
                        setOfficeData({ ...editOfficeData, latitude: lat.toString(), longitude: lng.toString() });
                      }
                      // else {
                      //   setOfficeData({ ...editOfficeData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                    }}
                  />

                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField fullWidth label="Input Latitude" name="latitude"
                    placeholder="Enter latitude" value={editOfficeData.latitude ? editOfficeData.latitude : ""}

                    disabled
                  />
                  <TextField fullWidth label="Input Longitude" name="longitude"
                    placeholder="Enter longitude" value={editOfficeData.longitude ? editOfficeData.longitude : ""}

                    disabled
                  />
                </Box>
                {/* File Upload Section */}
                {/* Office Photo */}
                {editOfficeData.previewUrl && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                      Office Photo
                    </Typography>
                    <Box
                      sx={{
                        border: "1px solid #e0e0e0",
                        padding: 2,
                        borderRadius: "8px",
                        backgroundColor: "#fafafa",
                        textAlign: "center"
                      }}
                    >
                      <img
                        src={editOfficeData.previewUrl}
                        alt="Office"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "8px",
                          objectFit: "contain",
                          maxHeight: 200,
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>

              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>

                <TextField
                  fullWidth label="Office Address" name="officeAddress"
                  placeholder="Enter Office Address" value={editOfficeData.officeAddress}

                  disabled
                />
                <TextField
                  select
                  fullWidth label="Input Office Region" name="region"
                  placeholder="Enter region" value={editOfficeData.region}

                  disabled
                >
                  <MenuItem value="">Select Region</MenuItem>
                  {regions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  fullWidth label="Input Province" name="province"
                  placeholder="Enter province" value={editOfficeData.province}

                  disabled
                />
                <TextField
                  fullWidth label="Input City" name="city"
                  placeholder="Enter city" value={editOfficeData.city}

                  disabled
                />
                <TextField
                  fullWidth label="Input District" name="district"
                  placeholder="Enter district" value={editOfficeData.district}

                  disabled
                />
                <TextField
                  fullWidth label="Input Office Manager" name="managerName"
                  placeholder="Enter manager name" value={editOfficeData.managerName}

                  disabled
                />

                {/* Office Contact & Email */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Input Office Contact Number" name="contactNumber"
                    placeholder="Enter contact number" value={editOfficeData.contactNumber}

                    disabled
                  />
                  <TextField
                    fullWidth label="Input Office Email" name="officeEmail"
                    placeholder="Enter email" value={editOfficeData.officeEmail}

                    disabled
                  />
                </Box>

                <TextField
                  select
                  fullWidth label="Input Office Type" name="officeType"
                  placeholder="Enter office type" value={editOfficeData.officeType}

                  disabled
                >
                  <MenuItem value="">Select Office Type</MenuItem>
                  {officeTypes.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                {/* Office Attachments */}
                {editOfficeData.attachments && editOfficeData.attachments.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                      Office Attachments ({editOfficeData.attachments.length})
                    </Typography>
                    <Box sx={{ maxHeight: 200, overflow: 'auto' }}>
                      {editOfficeData.attachments.map((attachment, index) => (
                        <Box
                          key={attachment.attachmentId}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: 2,
                            border: "1px solid #e0e0e0",
                            borderRadius: 1,
                            mb: 1,
                            backgroundColor: "white"
                          }}
                        >
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" fontWeight="bold">
                              {attachment.originalName}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {(attachment.fileSize / 1024 / 1024).toFixed(2)} MB • {new Date(attachment.createdAt).toLocaleDateString('id-ID')}
                            </Typography>
                            {attachment.description && (
                              <Typography variant="caption" display="block" color="textSecondary">
                                {attachment.description}
                              </Typography>
                            )}
                          </Box>
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleDownloadAttachment(attachment)}
                            title="Download File"
                          >
                            <Download />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </DialogContent>

          {/* Dialog Actions */}
          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            {!isEditing ? (
              // Tombol Edit Muncul di Awal
              <Button onClick={() => setIsEditing(true)} variant="contained" color="primary" sx={{ width: 120 }}>
                EDIT
              </Button>
            ) : (
              // Tombol Save & Cancel Muncul Saat Edit
              <>
                <Button onClick={() => setIsEditing(false)} variant="outlined" color="error" sx={{ width: 120 }}>
                  CANCEL
                </Button>
                <Button onClick={handleSubmitEditOffice} variant="contained" color="success" sx={{ width: 120 }}>
                  SAVE
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>




        {/* ======================= Filter Dialog ============================= */}
        <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)}>
          <DialogTitle>Advanced Search</DialogTitle>
          <DialogContent>
            {filters.map((filter, index) => {
              const usedFields = filters.map((f, i) => i !== index && f.field).filter(Boolean);
              const availableOptions = availableFilters.filter((opt) => !usedFields.includes(opt.value));

              return (
                <Box key={index} display="flex" alignItems="center" gap={1} mb={2}>
                  <TextField
                    select
                    value={filter.field}
                    onChange={(e) => handleFilterChange(index, "field", e.target.value)}
                    variant="outlined"
                    size="small"
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {availableOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  {filter.field === "officeType" ? (
                    <TextField
                      select
                      label="Office Type"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {officeTypes.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : (
                    <TextField
                      label="Value"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1 }}
                    />
                  )}

                  {index > 0 && (
                    <IconButton onClick={() => handleRemoveFilter(index)}>
                      <Remove />
                    </IconButton>
                  )}
                </Box>
              );
            })}

            {filters.length < availableFilters.length && (
              <Button startIcon={<Add />} onClick={handleAddFilter}>
                Add Filter
              </Button>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleResetFilters}>Reset Filter</Button>
            <Button onClick={handleCloseFilter}>Cancel</Button>
            <Button variant="contained" onClick={handleApplyFilters} disabled={isLoading}>
              {isLoading ? "Loading..." : "Apply"}
            </Button>
          </DialogActions>
        </Dialog>

      </Box>
  );
};

export default ProjectDetail;
